import React from 'react';
import withErrorBoundary from '@/utils/errorBoundary';

import type { ProtectionCardFactoryProps } from './protectionCard.types';
import ProtectionCardSkeleton from './ProtectionCardSkeleton';
import ActiveTrialVariant, { TRIAL_ACTIVE_PROTECTION_CARD_TYPE } from './variants/ActiveTrialVariant';
import PendingInvoiceVariant, { PENDING_INVOICE_PROTECTION_CARD_TYPE } from './variants/PendingInvoiceVariant';
import ProPlanVariant from './variants/ProPlanVariant';
import UpgradeCycleVariant from './variants/UpgradeCycleVariant';

const ProtectionCardFactory = ({
  testId = 'protection-card',
  isLoading = false,
  hasInvoice = false,
  isTrialActive = false,
  isTrialExpired = false,
  isAAClient = false,
  hideButtons = false,
  hideActivateTrial = false,
  onActivateProtectionPro,
  onActivateTrial,
  onUpgradeCycleClick,
  onPendingInvoiceClick,
  isTurbo = false,
  enableTrial = true,
  forceRenderingType,
  upgradeCycleEligible = false,
  upgradeCycleDiscountPercent = 0,
  upgradeCyclePricingLoading = false,
  upgradeCycleSelectedPlan,
}: ProtectionCardFactoryProps) => {
  if (isLoading) {
    return <ProtectionCardSkeleton />;
  }

  if (hasInvoice || forceRenderingType === PENDING_INVOICE_PROTECTION_CARD_TYPE) {
    return (
      <PendingInvoiceVariant
        testId={testId}
        onPendingInvoiceClick={onPendingInvoiceClick}
      />
    );
  }

  const isTrial = isTrialActive || isTrialExpired;

  if (isTrial || forceRenderingType === TRIAL_ACTIVE_PROTECTION_CARD_TYPE) {
    return (
      <ActiveTrialVariant
        testId={testId}
        hideButtons={hideButtons}
        onActivateProtectionPro={onActivateProtectionPro}
      />
    );
  }
  if (upgradeCycleEligible) {
    return (
      <UpgradeCycleVariant
        testId={testId}
        discountPercent={upgradeCycleDiscountPercent}
        isButtonLoading={upgradeCyclePricingLoading}
        onButtonClick={onUpgradeCycleClick}
        upgradeCycleSelectedPlan={upgradeCycleSelectedPlan}
      />
    );
  }

  return (
    <ProPlanVariant
      testId={testId}
      hideButtons={hideButtons}
      hideActivateTrial={isTurbo || hideActivateTrial}
      isAAClient={isAAClient}
      onActivateProtectionPro={onActivateProtectionPro}
      onActivateTrial={onActivateTrial}
      enableTrial={enableTrial}
    />
  );
};

export default withErrorBoundary(ProtectionCardFactory, 'ProtectionCardFactory');
